import React, { useEffect, useState } from "react";
import { gql, useMutation } from "@apollo/client";
import QRCode from "qrcode.react";
import { setup } from "../LockClient/setup";
import { ResultTypes } from "../LockClient/result";
import Error from "./Error";

enum SetupStatus {
  unknown,
  success,
  failure,
}

export default () => {
  const [error, setError] = useState<string | null>(null);
  const [status, setStatus] = useState(SetupStatus.unknown);
  const [remoteSetup, { called, data }] = useMutation(gql`
    mutation Setup {
      setup {
        qrcodeUrl
        key
        requestId
        resultEndpoint
      }
    }
  `);
  const [remoteConfirm, { called: confirming }] = useMutation(
    gql`
      mutation SetupComplete(
        $key: String!
        $digits: String!
        $deviceType: String!
        $requestId: String!
      ) {
        complete(
          key: $key
          digits: $digits
          deviceType: $deviceType
          requestId: $requestId
        ) {
          success
        }
      }
    `,
    {
      onCompleted: (data) => {
        setStatus(
          data.complete.success ? SetupStatus.success : SetupStatus.failure,
        );
      },
    },
  );
  useEffect(() => {
    if (called) return;
    remoteSetup();
  }, [remoteSetup, called]);
  useEffect(() => {
    if (!data?.setup?.resultEndpoint) return;
    if (!data?.setup?.key) return;
    if (!data?.setup?.requestId) return;

    async function inner() {
      const result = await setup(data.setup.resultEndpoint);
      if (result.type === ResultTypes.Err) {
        return setError(`${result.kind}: ${result.info?.toString() || ""}`);
      }
      remoteConfirm({
        variables: {
          key: data.setup.key,
          requestId: data.setup.requestId,
          digits: result.value.digits,
          deviceType: result.value.device_type,
        },
      });
    }

    inner();
  }, [data, remoteConfirm]);
  return (
    <div>
      {status === SetupStatus.unknown && (
        <OTPQrCode url={data?.setup?.qrcodeUrl} />
      )}
      {error && <Error>{error}</Error>}
      <span id="result" style={{ display: "none" }}>
        {statusToText(status)}
      </span>
      <Status status={status} confirming={confirming} />
    </div>
  );
};

const statusToText = (status: SetupStatus): string => {
  switch (status) {
    case SetupStatus.unknown:
      return "unknown";
    case SetupStatus.success:
      return "success";
    case SetupStatus.failure:
      return "failure";
  }
};

const Status = ({
  status,
  confirming,
}: {
  status: SetupStatus;
  confirming: boolean;
}) => {
  switch (status) {
    case SetupStatus.unknown:
      return confirming ? (
        <span>Confirming...</span>
      ) : (
        <span>Please scan the code with HENNGE Lock</span>
      );
    case SetupStatus.success:
      return <span>Success!!!</span>;
    case SetupStatus.failure:
      return <span>Failure :(</span>;
  }
};

const OTPQrCode = ({ url }: { url: string | null }) =>
  url ? (
    <QRCode value={url} size={265} renderAs="svg" level="Q" aria-label={url} />
  ) : null;
